import { render, staticRenderFns } from "./UnsubscribeEmailNotifications.vue?vue&type=template&id=4c1cba9e&scoped=true"
import script from "./UnsubscribeEmailNotifications.vue?vue&type=script&lang=js"
export * from "./UnsubscribeEmailNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cba9e",
  null
  
)

export default component.exports